export default __webpack_public_path__ + "static/media/bannerbg.b2d5faa1.png";